import { render, staticRenderFns } from "./exportHistory.vue?vue&type=template&id=32658efb&scoped=true"
import script from "./exportHistory.vue?vue&type=script&lang=js"
export * from "./exportHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32658efb",
  null
  
)

export default component.exports